import { createSelector } from '@reduxjs/toolkit';
import { getCheapestPackagePriceWithAlternatives } from '../../CheckoutRoutes/PackageCheckout/store/actualize-alternatives';
import { selectPriceFromHotelPage } from './actualization';
import { getFlightFuelCharge, getPackageFullPrice } from './order';
import { getNetPrice } from './package';
import { getIsHomePath } from './router';
import { cheapestTOExtrasTotalPriceSelector } from './services';

/**
 * Этот селектор возвращает предыдущую цену, которую видел юзер на странице отеля
 */
export const selectOldPrice = createSelector(
  [selectPriceFromHotelPage, getNetPrice],
  (priceFromHotelPage, origNetPrice): number =>
    priceFromHotelPage || origNetPrice,
);

/**
 * Этот селектор возвращает новую цену после актуализации
 * (или после актуализации альтернативных пакетов, если они включены):
 *  1) netPrice + extras + fuel_charge, если это первый шаг чекаута
 *  2) выбранного перелета, если второй или третий шаг
 */
export const selectNewPrice = createSelector(
  [
    getIsHomePath,
    getFlightFuelCharge,
    getCheapestPackagePriceWithAlternatives,
    cheapestTOExtrasTotalPriceSelector,
    getPackageFullPrice,
  ],
  (
    isFirstPage,
    fuelCharge,
    cheapestNetPrice,
    cheapestMandatoryExtrasPrice,
    fullPrice,
  ): number =>
    isFirstPage
      ? cheapestNetPrice + cheapestMandatoryExtrasPrice + fuelCharge
      : fullPrice || 0,
);
